<template>
  <div class="pl-6 pr-6 pt-0 pb-3">
    <v-row class="pa-0">
      <v-col cols="3" class="pl-0">
        <v-select 
          v-model="selectedOrg"
          label="Target Organisation" 
          :items="orgs"
          item-text="name"
          item-value="id"
          ></v-select>
      </v-col>

      <v-col cols="3">
        <v-select 
          v-model="selectedGroup"
          label="Target Group" 
          :items="orgGroups"
          :loading="orgTreeLoading"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
      <v-spacer/>
      <v-col cols="1" class="pr-0">
        <v-btn
          text
          class="config-btn"
          :disabled="loading"
          @click.native="selectFile"
        >
          <v-icon color="#0f74bb">
            mdi-file-upload
          </v-icon>
          <input 
            id="fileUpload"
            type="file" 
            hidden
            accept=".csv"
            @change="handleCSVUpload"
          >
        </v-btn>
        
      </v-col>
    </v-row>
    <v-row>
      <v-simple-table 
      class="asset-assignment-table pl-0" 
      fixed-header
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left pl-0">
                IMEI
              </th>
              <th class="text-left pl-0">
                Serial
              </th>
              <th class="text-left pl-0">
                Asset Type
              </th>
              <th class="text-left pl-0">
                Asset Name
              </th>
              <th class="text-left pl-0">
                Notes
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in sortedAssets"
              :key="item.IMEI"
            >
              <td class=" pl-0" :class="{ 'show-error': checkForError('invalid_imei', index) }">
                <span v-if="checkForError('invalid_imei', index)" class="show-error">Invalid IMEI</span>
                <span v-else>{{ item.IMEI }}</span>
              </td>
              <td class=" pl-0">{{ item.serial_number }}</td>
              <td class=" pl-0">
                <template>
                  <span v-if="checkForError('invalid_type', index)" class="show-error">Trailer</span>
                  <v-select 
                    v-else
                    v-model="item.asset_type"
                    :items="assetTypes"
                    >
                  </v-select>
                </template>
              </td>
              <td class=" pl-0">
                <template>
                  <v-text-field
                    v-model="item.asset_name"
                    :class="{ 'show-error': checkForError('invalid_name', index) }"
                    :disabled="disableAssetNameField"
                    :loading="loadingAssets"
                    outlined
                    :placeholder="item.IMEI"
                  ></v-text-field>
                </template>
              </td>
              
              <td class=" pl-0">
                <template>
                  <v-text-field
                    v-model="item.notes"
                  ></v-text-field>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
    <v-row class="pb-0">
      <v-col v-if="uploadErrorMessage != ''" cols="7" class="pb-0">
        <span class="upload-error">{{uploadErrorMessage}}</span>
      </v-col>
      <v-spacer/>
      <v-col cols="1" class="pb-0">
        <v-btn text @click="close">cancel</v-btn>
      </v-col>
      <v-col cols="1" class="pb-0">
        <v-btn text :disabled="disableSubmit" :loading="loading" @click="submitWrapper">submit</v-btn>
      </v-col>
    </v-row>

    <Dialog
      v-if="showWarning"
      :display="showWarning"
      :title="'Confirm Operation'"
      :state="false"
      :res="{}"
      @close="showWarning = false"
    >
      <v-row>
        <v-col cols="2" class="pl-8">
          <v-icon large color="orange">
            mdi-alert
          </v-icon>
        </v-col>
        <v-col cols="10" class="pr-6">
          The assets below already exist in the target organisation. If you continue with this operation, the devices assigned to these assets will be unassigned and replaced. Are you sure you want to proceed?
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pl-8 pr-8">
          <div class="bordered">
            <v-list disabled>

              <v-list-item-group>
                <v-list-item
                  v-for="(item, i) in getDuplicateAssetNames"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-btn text color="#0f74bb" @click="showWarning = false">
            no
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="2">
          <v-btn class="pl-8" color="#0f74bb" text :loading="loading" @click="assignAssetsToOrg">
            yes
          </v-btn>
        </v-col>
      </v-row>
    </Dialog>
  </div>
</template>

<script>

import { GetOrgTree, assignAssetToOrg, getOrgAssets } from "@/services/API.js";

import Dialog from "@/components/general/Dialog.vue";

import { Logger } from "aws-amplify"
const logger = new Logger("Asset assignment")

export default {
  name: 'AssetAssignment',

  components: {
    Dialog
  },

  props: {
    assets: {
      type: Array,
      required: true
    },
    orgs: {
      type: Array,
      required: true
    },
    defaultOrg: {
      type: String,
      required: true
    },
    display: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  
  data() {
    return {
      selectedOrg: null,
      selectedGroup: null,
      orgGroups: [],
      orgTreeLoading: false,
      formattedAssets: [],
      assetTypes: [
        'Trailer'
      ],
      defaultType: 'Trailer',
      loading: false,
      uploadErrorMessage: '',
      orgAssets: [],
      totalPages: 1,
      showWarning: false,
      loadingAssets: false,
      isUploadedList: false,
      uploadErrors: []
    }
  },

  computed: {
    sortedAssets() {
      let data = this.formattedAssets
      return data
    },

    hasEmptyAssetName() {
      return this.formattedAssets.some(item => item.asset_name === "");
    },

    disableSubmit() {
      return this.loadingAssets || this.selectedOrg == null || this.selectedGroup == null || this.uploadErrorMessage != '' || this.hasEmptyAssetName || this.containsDublicateNames ? true : false
    },

    containsDublicateNames() {
      return this.hasDuplicateNames(this.formattedAssets)
    },

    disableAssetNameField() {
      return this.loadingAssets || this.selectedOrg == null || this.selectedGroup == null ? true : false
    },

    getDuplicateAssetNames() {

      const assetNamesB = new Set(
        this.orgAssets.map(item => item.asset_name?.toLowerCase().trim()).filter(Boolean)
      );

      const duplicates = new Set();

      for (const item of this.formattedAssets) {
        const nameA = item.asset_name?.toLowerCase().trim();
        if (nameA && assetNamesB.has(nameA)) {
          duplicates.add(item.asset_name);
        }
      }

      return Array.from(duplicates);
    }
  },

  watch: {
    selectedOrg(id) {
      this.selectedGroup = null;
      this.fetchOrgNodes(id);
      this.getAllOrgAssets(id)
    },

    selectedGroup(id) {
      this.formattedAssets.forEach(obj => {
        if (obj.hasOwnProperty('node_id')) {
          obj['node_id'] = id
        }
      })
    },

    display() {
      logger.info('display watcher', this.display, this.assets)
      if(this.display){
        this.formatAssets()
      } else {
        this.selectedOrg = null
        this.selectedGroup = null
      }
    }
  },

  mounted() {
    logger.info('asset assignment mounted')
    this.formatAssets()
    this.isUploadedList = false
  },

  methods: {
    checkForError(errorType, index) {
      let offsetIndex = index + 1
      let target = {}
      target[errorType] = offsetIndex

      return this.uploadErrors.some(obj =>
        Object.keys(target).length === Object.keys(obj).length &&
        Object.entries(target).every(([k, v]) => obj[k] === v)
      )
    },

    close() {
      this.$emit('close')
    },

    refresh() {
      this.$emit('refresh')
    },

    submitWrapper() {
      if (this.compareArraysForMatchingNames(this.formattedAssets, this.orgAssets)) {
        this.showWarning = true
      } else {
        this.assignAssetsToOrg()
      }
    },

    hasDuplicateNames(arr) {
      const seen = new Set();
      
      for (const obj of arr) {
        if (obj.asset_name) { // make sure obj has a "name" property
          if (seen.has(obj.asset_name)) {
            return true; // duplicate found
          }
          seen.add(obj.asset_name);
        }
      }
      
      return false; // no duplicates
    },

    compareArraysForMatchingNames(arrayA, arrayB) {
      // Extract asset_name values from arrayB and normalize to lowercase
      const assetNamesB = new Set(
        arrayB.map(item => item.asset_name?.toLowerCase().trim()).filter(Boolean)
      );

      // Check each asset_name in arrayA against the normalized names in arrayB
      for (const item of arrayA) {
        const nameA = item.asset_name?.toLowerCase().trim();
        if (nameA && assetNamesB.has(nameA)) {
          return true; // Found a match
        }
      }

      return false; // No matches found
    },

    async assignAssetsToOrg() {
      this.showWarning = false
      this.loading = true
      const copyOfAssets = this.formattedAssets.map(obj => ({ ...obj }))
      const payload = copyOfAssets.map(obj => {
        if(!this.isUploadedList) {
          delete obj.IMEI
        }
        if(!Object.hasOwn(obj, 'node_id') || !obj['node_id'] || obj['node_id'] == '') {
          obj['node_id'] = this.selectedGroup
        }
        delete obj.serial_number	
        return obj
      })

      const assign = await assignAssetToOrg(this.selectedOrg, payload)
      
      if(assign && Object.hasOwn(assign, 'message') && assign.message == 'Assigments sent to be processed.') {
        this.loading = false
        this.formattedAssets = []
        this.refresh()
        this.close()
      } else {
        this.loading = false
        throw new Error('Error assigning asset(s) to org')
      }

    },

    formatAssets() {
      logger.info('format assets', this.assets)
      this.formattedAssets = this.assets.map((asset) => {
          return { 
            IMEI: asset.imei,
            serial_number: asset.serial_number,
            asset_type: 'Trailer',
            asset_name: '',
            notes: '',
            physical_device_id: asset.id,
            year: '',
            node_id: this.selectedGroup,
            visible: true
          }
      })
    },

    async fetchOrgNodes(id) {
      this.orgTreeLoading = true;

      try {
        const orgTree = await GetOrgTree(id);

        if (orgTree && orgTree.hasOwnProperty('root_node')) {
          logger.info('fetchOrgNodes', orgTree)
          this.selectedGroup = orgTree.root_node.id
          this.orgGroups =  this.flattenOrgTree([orgTree.root_node]);
          this.orgTreeLoading = false;
        }
      } catch {
        this.orgTreeLoading = false;
      }
      
    },

    async getAllOrgAssets(id) {
      this.loadingAssets = true

      const allResults = [];
      let currentPage = 1;

      for (let i = 0; i < this.totalPages; i++) {
        try {
          currentPage = i + 1;

          const assets = await getOrgAssets(
            id,
            currentPage,
            50
          );

          if (!assets) {
            throw new Error(`Request failed`);
          }
          const data = await assets.Assets;

          this.totalPages = assets.page_size;

          if (Array.isArray(data)) {
            allResults.push(...data);
          } else {
            throw new Error(`Result is not array ${assets.Assets}`);
          }
        } catch (error) {
          throw new Error(`Error during API call ${i + 1}:`, error);
        }
      }

      this.orgAssets = allResults;
      this.loadingAssets = false
    },

    flattenOrgTree(node) {
      try {
        var result = [];

        node.forEach((a) => {
          result.push({
            name: a.metadata.label,
            id: a.id
          });
          if (Array.isArray(a.nodes)) {
            let nextNode = this.flattenOrgTree(a.nodes)
            
            result = result.concat(nextNode);
          }
      });
      return result;

      } catch (err) {
        logger.info('error?', err)
      } 
    },

    handleCSVUpload(event) {
      this.formattedAssets = []
      this.uploadErrorMessage = ''
      this.isUploadedList = true

      const csvToArrayOfObjects = (csv, delimiter = ',') => {
        this.uploadErrors = []
        logger.info('csv', csv)
        
        if(csv.length <= 0) return 
        const lines = csv.trim().split('\n').filter(line => line.trim().length > 0);
        logger.info('lines', lines)
        const headers = parseCSVLine(lines[0], delimiter);
        let result = [];

        for (let i = 1; i < lines.length; i++) {
          const values = parseCSVLine(lines[i], delimiter);
          const obj = {};
          const headerMap = {
            'imei': 'IMEI',
            'IMEI': 'IMEI',
            'asset type': 'asset_type',
            'asset name': 'asset_name',
            'asset description': 'notes'
          }

          headers.forEach((header, index) => {
            obj[headerMap[header.toLowerCase()]] = values[index];
          });

          // Validate fields
          if(!('IMEI' in obj) || !('asset_type' in obj) || !('asset_name' in obj) || !('notes' in obj)) {
            this.uploadErrorMessage = 'Missing required field'

            throw new Error('Missing required field')
          }
          
          if('IMEI' in obj && !obj.IMEI || obj.IMEI == '' || isNaN(Number(obj.IMEI)) || obj.IMEI.length < 15) {
            let error = {
              'invalid_imei': i
            }

            this.uploadErrors.push(error)
          }
  
          if('asset_type' in obj && obj.asset_type != 'Trailer') {
            let error = {
              'invalid_type': i
            }

            this.uploadErrors.push(error)
          }

          if('asset_name' in obj && obj.asset_name == '') {
            let error = {
              'invalid_name': i
            }
            
            this.uploadErrors.push(error)
          }

          if(this.uploadErrors.length > 0) {
            this.uploadErrorMessage = `${this.uploadErrors.length} issue(s) encountered during import - please check the source data file for errors.`
          }
          // add missing but required fields
          obj['year'] = ''
          obj['node_id'] = ''
          obj['visible'] = true
          
          result.push(obj);
        }

        return result;
      }
      const parseCSVLine = (line, delimiter = ',') => {
        // DO NOT automatically add a delimiter
        const regex = new RegExp(
          `(?:^|${delimiter})(?:"((?:[^"]|"")*)"|([^"${delimiter}\\r\\n]*))`,
          'g'
        );

        const result = [];
        let match;

        try {
          while ((match = regex.exec(line))) {
            if (match.index === regex.lastIndex) regex.lastIndex++; // <-- Prevent infinite loop
            if (match[1] !== undefined) {
              result.push(match[1].replace(/""/g, '"'));
            } else if (match[2] !== undefined) {
              result.push(match[2]);
            } else {
              result.push('');
            }
          }

          return result;
        } catch (err) {
          logger.info('parse error', err);
          return [];
        }
      }


      const setNewAssets = (data) => {
        this.formattedAssets = data
      }

      const file = event.target.files[0];
      if (!file) return;
      

      const reader = new FileReader();
      reader.onload = function (e) {
        const csvContent = e.target.result;
        const data = csvToArrayOfObjects(csvContent);

        setNewAssets(data)
      };

      reader.readAsText(file);
      logger.info('uploaded csv', this.formattedAssets)
    },

    selectFile() {
      document.getElementById("fileUpload").click()
    },
  }
}
</script>

<style lang="scss">
  .asset-assignment-table {
    width: 100%;
    max-height: 350px;
    overflow-y: scroll;
  }
  .upload-error {
    color: red;
  }
  .bordered {
    border: solid lightgray 2px;
  }
  .show-error {
    color: red !important;
    .v-select__selections {
      color: red !important;
    }
  }
  .show-error input {
    color: red !important;
  }

  .show-error {
    ::placeholder {
      color: red !important;
      opacity: 1 !important;
    }

    ::-ms-input-placeholder {
      color: red !important;
    }
  }
</style>